import { ReactElement, useEffect, useMemo } from 'react';
import { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { Page, StyledTabs } from '@ohpen/enso-ui';
import {
  ProcurationFeesTab,
  ProcurationFeeRulesTab,
  PROCURATION_FEES_VALUE_LIST_NAMES,
  getProcurationFeeOptions,
  ProcurationFeeCalculator,
} from '@pmp/components';

import styles from './styles.module.css';
import { usePmpFetch } from '@pmp/hooks';
import { useValueListsStore } from '@pmp/stores';

export const ProcurationFeesPage = (): ReactElement => {
  const [isFetching, , procurationFees, , fetchProcurationFees] = usePmpFetch('procurationFeesGetAllProcurationFees');
  const { valueLists, getValueLists } = useValueListsStore();
  const { t } = useTranslation();

  useEffect(() => {
    getValueLists({ fetchIfMissing: PROCURATION_FEES_VALUE_LIST_NAMES });
  }, [getValueLists]);

  useEffect(() => {
    fetchProcurationFees();
  }, [fetchProcurationFees]);

  const tabItems: TabsProps['items'] = useMemo(() => {
    const feeRulesValueLists = { ...valueLists, PROCURATION_FEES: getProcurationFeeOptions(procurationFees) };
    const items = [
      {
        key: 'fees',
        label: t('lender.procurationFees.labels.feesList'),
        children: (
          <ProcurationFeesTab valueLists={valueLists} data={procurationFees} isFetching={isFetching} fetchData={fetchProcurationFees} />
        ),
      },
      {
        key: 'rules',
        label: t('lender.procurationFees.labels.feeRules'),
        children: <ProcurationFeeRulesTab valueLists={feeRulesValueLists} />,
      },
      {
        key: 'calculator',
        label: t('lender.procurationFees.labels.feeCalculator'),
        children: <ProcurationFeeCalculator />,
      },
    ];

    return items;
  }, [valueLists, procurationFees, t, isFetching, fetchProcurationFees]);

  return (
    <Page>
      <Page.Title>{t('lender.procurationFees.title')}</Page.Title>
      <Page.Content>
        <StyledTabs defaultActiveKey="fees" items={tabItems} className={styles.tabs} />
      </Page.Content>
    </Page>
  );
};
